import { OrderStatus } from "../@core/constants";
import { OrderCheckListEntry } from "./order-checklist-entry";

export class OrderCheckList {
    code: string;
    orderCode: string;
    invoiceCode: string;
    invoiceNumber: string;
    branchCode: string;
    branchName: string;
    customerCode: string;
    customerName: string;
    customerFiscalId: string;
    salesOrgCode: string;
    entries: Array<OrderCheckListEntry>;
    status: OrderStatus;
    startDate: string;
    endDate: string;
    sellerCode: string;
    sellerName: string;
    rejectedReason: string;
    voidDate: string;
    voidReason: string;
    isForEquipment: boolean;
    constructor() {
        this.code = "";
        this.orderCode = "";
        this.invoiceCode = "";
        this.invoiceNumber = "";
        this.branchCode = "";
        this.branchName = "";
        this.customerCode = "";
        this.customerName = "";
        this.customerFiscalId = "";
        this.salesOrgCode = "";
        this.entries = [];
        this.status = OrderStatus.NONE;
        this.startDate = "";
        this.endDate = "";
        this.sellerCode = "";
        this.sellerName = "";
        this.rejectedReason = "";
        this.voidDate = "";
        this.voidReason = "";
        this.isForEquipment = false;
    }
}